export const SubscriptionFields = [
  {
    type: 'text',
    name: 'first_name',
    hasLabel: false,
    placeholder: 'First Name',
    required: true,
    pattern: '^[a-zA-Z\\s]*$',
  },
  {
    type: 'text',
    name: 'last_name',
    hasLabel: false,
    placeholder: 'Last Name',
    required: true,
    pattern: '^[a-zA-Z\\s]*$',
  },
  {
    type: 'email',
    name: 'email',
    hasLabel: false,
    placeholder: 'Email Address',
    required: true,
    pattern: '^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$',
  },
];
